import React from "react";
import { Icon } from "antd";

export default function CheckIcon(bool) {
    return bool ? <Icon type={"check"} /> : null;
}
